export default "__VITE_ASSET__CYB3RPVY__"